import React from "react";
import {
  BomHeaderType,
  BomInputType,
  BomOutputType,
  SelectOption,
} from "../../../../commonTypes/billOfMaterial";
import Select, { OptionProps, components } from "react-select";
import { TableHeadersType } from "../../../../constant/tableHeadersConstants/tableHeadersType";
import { AccordionIcon, AccordionIconClose, RedDeleteIcon } from "../../../../assets/images";
import { DropDown } from "../../../commons";
import { changeToDecimel, formatDate } from "../../../../utils/commonFunctions";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

type AppProps = {
  data: BomInputType[] | BomOutputType[];
  headers: TableHeadersType[];
  deleteData: (type: string, index: number) => void;
  type: string;
  templateId?: string;
  fetching: boolean;
  branchOption?: SelectOption[];
  allStockItemOption?: SelectOption[];
  checkStockItemTypeBottom: () => void;
  setStockItemText: any;
  currencySign: string | undefined;
  bomHeaderData: BomHeaderType;
  handleInputChange: (
    e: any,
    type: string,
    inputType: string,
    index: number
  ) => void;
  toggleRow?: (index: number, data: any) => void;
  handlePrimaryDetails?: any;
  checkBranchTypeBottom?: any;
  allBatchOption?: any;
  handleGetSelectedbatch?: (data1: any, data2: any, type: string) => void;
  autoUniqueNumberGenerationData?: any;
  batchFetching:boolean;
  isMenuOpen:boolean;

};

const inputDropDownStyle = {
  option: (baseStyles: any, state: any) => ({
    ...baseStyles,
    width: "100%",
  }),
  control: (provided: any, state: any) => ({
    ...provided,
    width: "100%",
  }),
  container: (provided: any) => ({
    ...provided,
    width: "120%",
  }),
};

const outputDropDownStyle = {
  option: (baseStyles: any, state: any) => ({
    ...baseStyles,
    width: "100%",
  }),
  control: (provided: any, state: any) => ({
    ...provided,
    width: "90%",
  }),
  container: (provided: any) => ({
    ...provided,
    width: "120%",
  }),
};

const BomTableData = ({
  data,
  headers,
  templateId,
  deleteData,
  currencySign,
  type,
  branchOption,
  fetching,
  checkStockItemTypeBottom,
  setStockItemText,
  allStockItemOption,
  bomHeaderData,
  handleInputChange,
  toggleRow,
  handlePrimaryDetails,
  checkBranchTypeBottom,
  allBatchOption,
  handleGetSelectedbatch,
  autoUniqueNumberGenerationData,
  batchFetching,
  isMenuOpen


}: AppProps) => {
  const getTableData = (
    data: BomInputType[] | BomOutputType[],
    headers: TableHeadersType[],
    deleteData: Function,
    type: string
  ) => {
    const renderItem = (item: BomInputType | BomOutputType, index: number) => {
      return (
        <div style={{ minWidth: "150px", maxWidth: "150px" }}>
          <Select<any, false>
            classNamePrefix="react-select"
            inputProps={{ autoComplete: "nope" }}
            options={
              allStockItemOption
                ? [{ label: "Select...", value: "" }, ...allStockItemOption]
                : []
            }
            styles={
              type === "InputGoods" ? inputDropDownStyle : outputDropDownStyle
            }
            className={`react-select`}
            value={item?.itemName}
            isDisabled={!bomHeaderData?.date || !!templateId}
            onChange={(e: any) => {
              handleInputChange(e, type, "itemName", index);
            }}
            isSearchable
            isLoading={fetching}
            onMenuScrollToBottom={checkStockItemTypeBottom}
            onInputChange={(e) => {
              setStockItemText(e);
            }}
          />

          <div className="stocks mt-1">{item?.type}</div>
        </div>
      );
    };

    let finalData = data?.map(
      (item: BomInputType | BomOutputType, index: number) => {
        return (
          <React.Fragment key={index}>
            <tr >

              {headers?.map((header: TableHeadersType) => {
                if (header?.value === "item") {
                  return (
                    <td key={header.value} style={{ width: "150px", paddingTop: item?.type && "30px" }}>
                      <div className="d-flex align-item-center" >
                        {autoUniqueNumberGenerationData?.is_enable === 1 ?
                          <span style={{ marginRight: "5px", cursor: "pointer" }} onClick={() => toggleRow?.(index, item?.itemName)}>
                            {item?.isOpen ? <img src={AccordionIcon} /> : <img src={AccordionIconClose} />}
                          </span>
                          : ""}
                        <div>
                          {item?.itemName?.label?.length > 15 ? (
                            <OverlayTrigger
                              placement="top"
                              delay={{ show: 250, hide: 250 }}
                              overlay={
                                <Tooltip id="button-view-open-item">
                                  {item?.itemName?.label}
                                </Tooltip>
                              }
                            >
                              {renderItem(item, index)}
                            </OverlayTrigger>
                          ) : (
                            renderItem(item, index)
                          )}
                        </div>
                      </div>
                    </td>
                  );
                } else if (header?.value === "location") {
                  return (
                    <td style={{ width: "150px" }}>
                      {
                        <div style={{ minWidth: "150px", maxWidth: "150px" }}>
                          <DropDown
                            placeholder="Choose branch name..."
                            style={
                              type === "InputGoods"
                                ? inputDropDownStyle
                                : outputDropDownStyle
                            }
                            options={
                              branchOption
                                ? [
                                  { value: "", label: "Select..." },
                                  ...branchOption,
                                ]
                                : []
                            }
                            handleChange={(e: any) => {
                              handleInputChange(e, type, "location", index);
                            }}
                            value={item?.location}
                            disabled={!bomHeaderData?.date || !!templateId}
                          />
                        </div>
                      }
                    </td>
                  );
                } else if (header?.value === "quantity") {
                  return (
                    <td>
                      <div style={{ marginTop: "15px" }}>
                        <div
                          className="d-flex align-items-center justify-content-start"
                          style={{
                            gap: "2px",
                            marginTop: item?.stocks?.length > 0 ? "0px" : "-15px",
                            paddingRight: !item?.itemName?.unit ? "4%" : "0px",
                          }}
                        >
                          <input
                            type="number"
                            className={"form-control"}
                            name="quantity"
                            min={"0"}
                            disabled={!bomHeaderData?.date || !!templateId}
                            style={{
                              width: type === "InputGoods" ? "80px" : "65px",
                            }}
                            onWheel={(event) => event.currentTarget.blur()}
                            value={item.quantity ? item.quantity : ""}
                            onChange={(e: any) => {
                              handleInputChange(e, type, "quantity", index);
                            }}
                          />
                          <div className="Bomtext">
                            {item?.itemName?.unit || item?.unit}
                          </div>
                        </div>

                        {type === "InputGoods" ? (
                          !!item?.stocks ? (
                            <div className="stocks">{`(${!!item?.stocks ? item?.stocks : 0
                              } in stock)`}</div>
                          ) : null
                        ) : (
                          <div className="stocks"></div>
                        )}
                      </div>
                    </td>
                  );
                } else if (header?.value === "rate") {
                  return (
                    <td>
                      {item?.rate ? (
                        <div>
                          {currencySign} {changeToDecimel(+item?.rate)}{" "}
                          {(!!item?.unit ? item?.unit : item?.itemName?.unit)
                            ? "/"
                            : ""}
                          {`${!!item?.unit ? item?.unit : item?.itemName?.unit}`}
                        </div>
                      ) : null}
                    </td>
                  );
                } else if (header?.value === "amount") {
                  return (
                    <td
                      style={{
                        textAlign: "left",
                        paddingRight: "0",
                        paddingLeft: "2px",
                      }}
                    >
                      <div className="amount">
                        <div>
                          {currencySign}{" "}
                          {item?.amount ? changeToDecimel(+item?.amount) : 0}
                        </div>

                        {!templateId ? (
                          <div className="pointer ml-1">
                            {(type === "InputGoods" && data?.length > 1) ||
                              type !== "InputGoods" ? (
                              <div onClick={() => deleteData(type, index)}>
                                <img src={RedDeleteIcon} alt="delete" />
                              </div>
                            ) : null}
                          </div>
                        ) : null}
                      </div>
                    </td>
                  );
                } else if (header?.value === "percentageOfCostAllocation") {
                  return (
                    <td>
                      <div>
                        <input
                          type="number"
                          className={"form-control"}
                          disabled={!bomHeaderData?.date || !!templateId}
                          name="percentageOfCostAllocation"
                          value={
                            item?.percentOfCostAllocation
                              ? item?.percentOfCostAllocation
                              : ""
                          }
                          onWheel={(event) => event.currentTarget.blur()}
                          onChange={(e: any) => {
                            handleInputChange(
                              e,
                              type,
                              "percentOfCostAllocation",
                              index
                            );
                          }}
                        />
                      </div>
                    </td>
                  );
                }
              })}
            </tr>
            {item?.isOpen && (

              <tr>
                <td colSpan={headers?.length} style={{ backgroundColor: "#f9f9f9" }}>
                  <div className=" batchHeader ">BATCH DETAILS</div>
                  <table className="table" style={{ borderCollapse: 'collapse', marginBottom: '0' }}>
                    <thead>
                      <tr style={{ borderBottom: '1px solid #dee2e6' }}>
                        <th className="  batchHeading">Batch Number</th>
                        <th className="  batchHeading">Manufacturing Date</th>
                        <th className="  batchHeading">Expiry Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                        <div style={{ minWidth: "150px", maxWidth: "190px" }}>

                          <Select<any, false>
                            className={`react-select `}
                            isDisabled={!bomHeaderData?.date || !!templateId}
                            inputProps={{ autoComplete: "nope" }}
                            // options={
                            //   index !== undefined && data[index]?.batchInputOptions
                            //     ? [{ label: "Select...", value: "" }, ...data[index].batchInputOptions]
                            //     : []
                            // }
                            options={
                              batchFetching && isMenuOpen 
                                ? [{ label: "Loading...", value: "" }]
                                : index !== undefined && data[index]?.batchInputOptions
                                  ? [{ label: "Select...", value: "" }, ...data[index].batchInputOptions]
                                  : []
                            }

                            value={item?.batchNumber}
                            onChange={(e: any) => handleInputChange(e, type, "batchNumber", index)}
                            isSearchable
                            isLoading={batchFetching}
                            onMenuScrollToBottom={checkBranchTypeBottom}
                            onInputChange={(e) => {
                              setStockItemText(e);
                            }}
                            onMenuOpen={() => {
                              handleGetSelectedbatch?.(index, item?.itemName, type);
                            }}
                          />
                          </div>

                        </td>
                        <td>
                          <div className="mt-1">
                            <div className=" costOfInputHeader">
                              {item?.batchNumber?.manufacturingDate ? formatDate(item?.batchNumber?.manufacturingDate) : "-"}
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className=" mt-1">

                            <div className=" costOfInputHeader">
                              {item?.batchNumber?.expiryDate ? formatDate(item?.batchNumber?.expiryDate) : "-"}

                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            )}
          </React.Fragment>
        );
      }
    );

    return finalData;
  };

  return <tbody>{getTableData(data, headers, deleteData, type)}</tbody>;
};

export default BomTableData;
